import { apiRequest } from "@services/apiClient";
import homeContentCarbonFootPrintEndpoints from "@services/homeContent/homeContentCarbonFootPrintEndpoints";

function normalizeCarbonFootPrintFromBody(body) {
  if (Array.isArray(body?.carbonFootPrint)) return body.carbonFootPrint;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body)) return body;
  return [];
}

export async function listHomeContentCarbonFootPrintRequest() {
  const response = await apiRequest(homeContentCarbonFootPrintEndpoints.base);
  return {
    ...response,
    body: normalizeCarbonFootPrintFromBody(response?.body),
  };
}

export async function createHomeContentCarbonFootPrintRequest(payload) {
  const response = await apiRequest(homeContentCarbonFootPrintEndpoints.base, {
    method: "POST",
    body: payload,
  });
  return {
    ...response,
    body: normalizeCarbonFootPrintFromBody(response?.body),
  };
}

export async function updateHomeContentCarbonFootPrintRequest(payload) {
  const response = await apiRequest(homeContentCarbonFootPrintEndpoints.base, {
    method: "PUT",
    body: payload,
  });
  return {
    ...response,
    body: normalizeCarbonFootPrintFromBody(response?.body),
  };
}

export async function saveHomeContentCarbonFootPrintRequest(payload) {
  try {
    return await updateHomeContentCarbonFootPrintRequest(payload);
  } catch (error) {
    if (Number(error?.status) === 404) {
      return createHomeContentCarbonFootPrintRequest(payload);
    }
    throw error;
  }
}

export function deleteHomeContentCarbonFootPrintRequest(id) {
  return apiRequest(homeContentCarbonFootPrintEndpoints.byId(id), {
    method: "DELETE",
  });
}
